enum TOOL_RENDER_MODE {
	DEFAULT = 'default',
	BACKGROUND = 'background'
}

enum API_ERROR_CODES {
  NON_EXISTENT_PANEL = 'E_INVALID_PANEL',
  SUNROOF_DESIGN_NOT_AVAILABLE = 'NOT_FOUND',
  NEARMAP_DESIGN_NOT_AVAILABLE = 'SURVEYS_NOT_FOUND',
  INVALID_ADDRESS = 'E_INVALID_ADDRESS',
  INVALID_MODE_CHECKOUT = 'E_INVALID_MODE_CHECKOUT',
  INVALID_IMAGERY_CHECKOUT = 'E_INVALID_IMAGERY_CHECKOUT',
	INVALID_IMAGERY_CHECKOUOUT_SAME_CHECKOUT = 'E_INVALID_IMAGERY_CHECKOUT_SAME_CHECKOUT',
	DESIGN_DELETED = 'E_DESIGN_DELETED',
	ROLE_TOKEN_EXPIRED = 'ROLE_TOKEN_EXPIRED',
	GET_ROLE_TOKEN = 'GET_ROLE_TOKEN',
	SHADING_IN_PROGRESS = 'E_SHADING_IN_PROGRESS',
	DESIGN_NOT_READY = 'E_DESIGN_NOT_READY',
  DESIGN_BUILD_FAILED = 'E_BUILD_FAILED', //
}

enum PANEL_ENERGY_COLORS {
	HIGH = 'rgba(255, 209, 89, 0.5)',//'#FFD159',
	MEDIUM = 'rgba(255, 147, 43, 0.5)', //'#FF932B',
	LOW = 'rgba(222, 91, 18, 0.5)'
}

const PANEL_OFF_COLOR = 'rgba(0,0,0,0.4)';
const PANEL_ON_COLOR = 'rgb(0, 0, 0)';
const PANEL_STROKE_COLOR = 'rgba(186, 186, 186, 1)';
const STROKE_COLOR_FOR_USER_MAPPED_PANEL = '#FEB517';
const STROKE_COLOR_FOR_TEMP_ADDED_PANEL = '#2382ea';
const DEV_STROKE_COLOR = 'rgba(255, 209, 89, 0.5)';
const DEV_STROKE_FACET_COLOR = 'rgba(3, 122, 241, 0.8)';

// const SEMI_TRANPARENT_BLACK_PANEL = 'rgba(0,0,0,0.4)';
// const FULL_TRANPARENT_BLACK_PANEL = 'rgba(0, 0, 0, 0.1)';
const SEMI_TRANPARENT_BLACK_PANEL = 'rgb(0, 0, 0)';
const FULL_TRANPARENT_BLACK_PANEL = 'rgb(0, 0, 0)';

const FACET_HIGHLIGHT_COLOR = 'rgba(255, 255, 0, 0.3)';
const FACET_HIGHLIGHT_OFF_COLOR = 'rgba(0,0,0,0)';
const FACET_DEFAULT_FILL_COLOR_ROOF_TOOL = 'rgba(43,145,240, .33)';
const INVALID_PANEL_ARRAY_DRAG_COLOR = { stroke: 'red', fill: 'rgba(255,0,0,0.25)' };

const ENERGY_THRESHOLD_THAT_A_PANEL_MUST_HAVE = 480;

const MIN_PANELS_REQUIRED_FOR_DESIGN_TO_QUALIFY = 3;

const SOlAR_QOUTE_APP_NAME = 'SOLARQUOTE';
const SUBHUB_APP_NAME = 'SUBHUB';

enum PARENT_EVENTS {
	DESIGN_HAS_LESS_THEN_REQUIRED_PANELS = 'SOLARQUOTEEMBED_BAD_DESIGN',
	DESIGN_HAS_SUFFICIENT_PANELS = 'SOLARQUOTEEMBED_DESIGN_DATA_LOADED',
	SET_HOUSE = 'SOLARQUOTEEMBED_SET_HOUSE', // trigger event After design API call with uuid 
	PANEL_CHANGED = 'SOLARQUOTEEMBED_PANEL_CHANGED',
	SAVE_DESIGN_TRIGGER = 'SOLARQUOTEEMBED_SAVE_HOUSE_TRIGGERED',
	ENERGY_INPUTS_CHANGED = 'energyInputsChanged',
	FULL_VIEW_TOGGLE= 'FULL_VIEW_MODE',
	SAVE_DESIGN = 'SOLARQUOTEEMBED_SAVE_DESIGN',
	DESIGN_SYNCED = 'PARENT_SYNCED_WITH_TOOL',
	DESIGN_UNSYNCED = 'PARENT_UNSYNCED_WITH_TOOL',
	DESIGN_HAS_RESET = 'DESIGN_HAS_RESET',
	TOOL_LOADED = 'SOLARQUOTEEMBED_TOOL_LOADED',
	SET_HOUSE_MAP_LOADED = 'SOLARQUOTEEMBED_SET_HOUSE_MAP_LOADED', // on sethouse map load
	UPDATED_ROLE_TOKEN = 'UPDATED_ROLE_TOKEN',
	SAVE_HOUSE = 'SOLARQUOTEEMBED_SAVE_HOUSE', // event when design is saved
	SET_HOUSE_CLICKED = 'SOLARQUOTEEMBED_SET_HOUSE_CLICKED', // event when set house button is clicked in the parent
	DISPLAY_MODE_CHANGED = 'DISPLAY_MODE_CHANGED' // parent toggled light/dark mode

	/** Events When Tool Runs In Backgound... */
}

const MAX_BILL_AMOUNT = 20000;
const ENERGY_DERATE_RATE = 15;
// inverter  derate 4 and  groun_cov_ratio 0.4
// dc to ac conversion derate
// we use dc energy to calculate energy of panels in non default modes
// hence we use the below factor to change from dc to ac energy
const NREL_DC_TO_AC_DERATE_FACTOR = 4.4;
const NREL_BASE_DERATE_FACTOR = 0;
const BASE_SHADING = 11.08; 
const MIN_CUSTOM_SHADING = 14; // Minimum custom shading value
const MAX_CUSTOM_SHADING = 70; // Maximum custom shading value
const PREDEFINED_SHADING_VALUES = [14.08, 15.85, 20.28, 24.76];
const DEFAULT_ELECTRIC_UNIT_PRICE = 26.5;
const AZIMUTH_CONSTRAINT_DEFAULT_MODE = 60;
const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec', 'Year'];
const MAX_ZOOM_LIMIT= 1000;
const MAX_ZOOM_LIMIT_FOR_SAVE= 150000;
const MIN_ZOOM_LIMIT= 0.10;
const DEFAULT_KONVA_SCALE = 1;
const DEFAULT_KONVA_STAGE_POSITION = { x: 0, y: 0 };
// Handle size presets for RAW/RAW_LARGE obstructions.
// These are "base" sizes that are later scaled by zoom via `getObstructionHandleSize(...)`.
// - `fullScreen` vs `windowed`: layout mode
// - `square*`: rect/circle resize handles
// - `circle*`: polygon vertex handles
// - `*Small` is used when the base image is "small" (imgHeight <= 601, ~600px tall)
// - `*Default` is used for larger images
const OBSTRUCTION_HANDLE_SIZE_CONFIG = {
	fullScreen: {
		squareSmall: 8,
		squareDefault: 12,
		circleSmall: 4,
		circleDefault: 6,
	},
	windowed: {
		squareSmall: 4,
		squareDefault: 6,
		circleSmall: 2.5,
		circleDefault: 3.5,
	},
} as const;
const OBSTRUCTION_HANDLE_ZOOM_BASELINE = {
	fullScreen: 3.5,
	windowed: 1.667,
} as const;
// - zoomOut uses ratios of baseline (e.g. 0.35 = 35% of baseline zoom)
// - zoomIn uses offsets above baseline (e.g. 4.5 = baseline + 4.5)
// Changes here affect all obstruction handles (raw, raw-large, manual).
const OBSTRUCTION_HANDLE_ZOOM_SCALE_TABLE = {
	zoomOut: [
		{ maxRatio: 0.11, scaleFactor: 0.32 },
		{ maxRatio: 0.2, scaleFactor: 0.4 },
		{ maxRatio: 0.28, scaleFactor: 0.48 },
		{ maxRatio: 0.35, scaleFactor: 0.55 },
		{ maxRatio: 0.45, scaleFactor: 0.72 },
		{ maxRatio: 0.55, scaleFactor: 0.8 },
		{ maxRatio: 0.65, scaleFactor: 0.86 },
		{ maxRatio: 0.75, scaleFactor: 0.91 },
		{ maxRatio: 0.85, scaleFactor: 0.95 },
		{ maxRatio: 0.95, scaleFactor: 0.98 },
		{ maxRatio: 1, scaleFactor: 1 },
	],
	zoomIn: [
		{ maxOffset: 3, scaleFactor: 1 },
		{ maxOffset: 4.5, scaleFactor: 1.45 },
		{ maxOffset: 6, scaleFactor: 1.7 },
		{ maxOffset: 7.5, scaleFactor: 1.95 },
		{ maxOffset: 9, scaleFactor: 2.15 },
		{ maxOffset: 10.5, scaleFactor: 2.3 },
		{ maxOffset: 12, scaleFactor: 2.5 },
		{ maxOffset: 13.5, scaleFactor: 2.65 },
		{ maxOffset: 15, scaleFactor: 2.8 },
		{ maxOffset: 16.5, scaleFactor: 2.95 },
		{ maxOffset: 18, scaleFactor: 3.1 },
		{ maxOffset: 19.5, scaleFactor: 3.25 },
		{ maxOffset: 21, scaleFactor: 3.4 },
		{ maxOffset: 22.5, scaleFactor: 3.55 },
		{ maxOffset: 24, scaleFactor: 3.7 },
		{ maxOffset: 25.5, scaleFactor: 3.85 },
		{ maxOffset: 27, scaleFactor: 4 },
		{ maxOffset: 28.5, scaleFactor: 4.15 },
		{ maxOffset: 30, scaleFactor: 4.3 },
		{ maxOffset: 31.5, scaleFactor: 4.45 },
		{ maxOffset: 33, scaleFactor: 4.6 },
		{ maxOffset: 34.5, scaleFactor: 4.75 },
		{ maxOffset: 36, scaleFactor: 4.9 },
		{ maxOffset: 37.5, scaleFactor: 5.05 },
		{ maxOffset: 39, scaleFactor: 5.2 },
		{ maxOffset: 40, scaleFactor: 5.3 },
	],
} as const;
const IRRADIANCE_UPRATE_RATE = 15;
const UUUID_SEPERATOR = '@';

// values in inches
const SETBACK = {
	NONGUTTER: 18,
	GUTTER: 0,
	OBSTRUCTION: 0
};

enum IMAGERY_PROVIDER {
  SUNROOF = 'sunroof',
  NEARMAP = 'nearmap',
  // VEXCEL = 'vexcel',
  GOOGLE_STATIC = 'googleStatic',
  EAGLEVIEW = 'eagleview',
}

const MANUAL_ONLY_IMAGERY_PROVIDERS: string[] = [
	IMAGERY_PROVIDER.GOOGLE_STATIC,
	IMAGERY_PROVIDER.EAGLEVIEW,
];

const PREMIUM_IMAGERY_PROVIDERS = [
	IMAGERY_PROVIDER.NEARMAP,
	// IMAGERY_PROVIDER.VEXCEL,
];

enum DESIGN_MODES {
  DEFAULT = 'DEFAULT',
  NEARMAP_NREL_AUTOMATIC = 'NEARMAP_NREL_AUTOMATIC',
  NEARMAP_NREL_MANUAL = 'NEARMAP_NREL_MANUAL',
	DEFAULT_MANUAL = 'DEFAULT_MANUAL',
	IN_HOUSE_SIMULATION = 'IN_HOUSE_SIMULATION',
	IN_HOUSE_SIMULATION_MANUAL = 'IN_HOUSE_SIMULATION_MANUAL'
}

enum ROOF_DESIGN_MODES {
  DEFAULT = 'DEFAULT',
	MANUAL = 'MANUAL'
}

// Runtime enum for shading recompute status. Keep in sync with the `ShadingStatus`
// union type in global.d.ts (same string values).
enum SHADING_STATUS {
	PENDING = 'PENDING',
	QUEUED = 'QUEUED',
	RUNNING = 'RUNNING',
	COMPLETED = 'COMPLETED',
	FAILED = 'FAILED'
}

const IMAGERY_PROVIDER_KEY = {
	[IMAGERY_PROVIDER.NEARMAP]: 'nearmap',
	[IMAGERY_PROVIDER.SUNROOF]: 'solarInfo',
	// [IMAGERY_PROVIDER.VEXCEL]: 'vexcel',
	[IMAGERY_PROVIDER.GOOGLE_STATIC]: 'googleStaticTiffSource',
	[IMAGERY_PROVIDER.EAGLEVIEW]: 'eagleview',
};

enum KONVA_FACET_GROUP {
  EXISTING_GROUP_NAME = 'already-created',
  IN_PROGRESS_GROUP_NAME = 'in-process',
  GROUP_NAME_SEPARATOR = '@',
	CENTER_ARROW_ID_SUFFIX = 'centerarrow',
	LINE_ID_SUFFIX = 'line',
	PANEL_GROUP_SUFFIX = 'panels',
	AZIMUTH_SELECTOR_SUFFIX= 'azimuth-selector'
}

enum KONVA_OBS_GROUP {
  IN_PROGRESS_GROUP_NAME = 'obs-in-process',
  GROUP_NAME_SEPARATOR = '@',
	LINE_ID_SUFFIX = 'obs-line',
	RECT_ID_SUFFIX = 'obs-rectangle',
	CIRCLE_ID_SUFFIX = 'obs-circle',
}
enum FACET_TYPE {
    FLAT = 'flat',
}

const BREAK_POINT_FOR_MOBILE_VIEW = 935;//(in px)
const RIGHT_PANEL_MOBILE_BREAKPOINT = 980;//(in px)
/*
	max-width of the dispaly energy panel in full view mode 
 	for screens >BREAK_POINT_FOR_MOBILE_VIEW
*/
const FULL_VIEW_POSITION_SHIFT_IN_PIXELS= 400;
const STANDARD_IMAGERY_SIZE = 600; //(600x600 px)

const PUERTI_RICO_STATE_CODE = 'PR';
const DEFAULT_SHADING_VAL = 14.08;
const PANEL_OVERLAP_THRESHOLD = 0.5;
const GROUND_MOUNT_DEFAULT_PITCH = 18;
const NORMAL_FACET_DEFAULT_PITCH = 20;
const FLAT_ROOF_DEFAULT_PITCH = 0;
const STARTING_HEIGHT_DEFAULT_FEET = 0;
const BASE_DERATE_FROM_SUBHUB = 5.5; // determined by subhub()
// NOTE: Here we didnt add "switch-design-mode" and "toggle-panels" because these actions do not exist in EditToolOptions
const PANEL_OPS = ['add-panels-exterior-coords','remove-panels','transform-panels'];
const SOLAR_FACET_OPS_WITH_BUTTON_ON_UI = ['edit-roof-segments','rotate-roof-segments',
	'remove-roof-segment-shading','undo-remove-roof-segment-shading','delete-obstructions','reset-layout','update-facets-coords'];
const SOLAR_FACET_OPS = ['translate-panels-to-new-position','update-roof-pitch',...SOLAR_FACET_OPS_WITH_BUTTON_ON_UI];
const ROOF_FACET_OPS = ['edit-roof-segments', 'update-facets-coords', 'update-roof-pitch', 'edit-gutter-lines', 'upsert-roof-segment-edges'];

enum ALL_ACTIONS {
	ADD_PANELS_EXTERIOR_COORDS = 'add-panels-exterior-coords',
	REMOVE_PANELS = 'remove-panels',
	TRANSFORM_PANELS = 'transform-panels',
	TRANSLATE_PANELS_TO_NEW_POSITION = 'translate-panels-to-new-position',
	EDIT_ROOF_SEGMENTS = 'edit-roof-segments',
	ROTATE_ROOF_SEGMENTS = 'rotate-roof-segments',
	REMOVE_ROOF_SEGMENT_SHADING = 'remove-roof-segment-shading',
	UNDO_REMOVE_ROOF_SEGMENT_SHADING = 'undo-remove-roof-segment-shading',
	DELETE_OBSTRUCTIONS = 'delete-obstructions',
	RESET_LAYOUT = 'reset-layout',
	UPDATE_FACETS_COORDS = 'update-facets-coords',
	UPDATE_ROOF_PITCH = 'update-roof-pitch',
	EDIT_GUTTER_LINES = 'edit-gutter-lines',
	UPSERT_ROOF_SEGMENT_EDGES = 'upsert-roof-segment-edges',
	SWITCH_DESIGN_MODE = 'switch-design-mode',
	TOGGLE_PANELS = 'toggle-panels',
	ADD_OBSTRUCTIONS = 'add-obstructions'
}
const FINAL_IMAGE_PADDING_VALUE_PERCENTAGE = 0.1;
export {
	PANEL_ENERGY_COLORS,
	PANEL_OFF_COLOR,
	PANEL_ON_COLOR,
	PANEL_STROKE_COLOR,
	ENERGY_THRESHOLD_THAT_A_PANEL_MUST_HAVE,
	MIN_PANELS_REQUIRED_FOR_DESIGN_TO_QUALIFY,
	PARENT_EVENTS,
	SOlAR_QOUTE_APP_NAME,
	ENERGY_DERATE_RATE,
	DEFAULT_ELECTRIC_UNIT_PRICE,
	SUBHUB_APP_NAME,
	AZIMUTH_CONSTRAINT_DEFAULT_MODE,
	SEMI_TRANPARENT_BLACK_PANEL,
	FULL_TRANPARENT_BLACK_PANEL,
	MONTHS,
	MAX_ZOOM_LIMIT,
	MIN_ZOOM_LIMIT,
	DEFAULT_KONVA_SCALE,
	DEFAULT_KONVA_STAGE_POSITION,
	OBSTRUCTION_HANDLE_SIZE_CONFIG,
	OBSTRUCTION_HANDLE_ZOOM_BASELINE,
	OBSTRUCTION_HANDLE_ZOOM_SCALE_TABLE,
	STROKE_COLOR_FOR_USER_MAPPED_PANEL,
	IRRADIANCE_UPRATE_RATE,
	IMAGERY_PROVIDER,
	IMAGERY_PROVIDER_KEY,
	FULL_VIEW_POSITION_SHIFT_IN_PIXELS,
	UUUID_SEPERATOR,
	KONVA_FACET_GROUP,
	BREAK_POINT_FOR_MOBILE_VIEW,
	DESIGN_MODES,
	API_ERROR_CODES,
	MAX_ZOOM_LIMIT_FOR_SAVE,
	SETBACK,
	FACET_HIGHLIGHT_COLOR,
	FACET_HIGHLIGHT_OFF_COLOR,
	INVALID_PANEL_ARRAY_DRAG_COLOR,
	NREL_DC_TO_AC_DERATE_FACTOR,
	NREL_BASE_DERATE_FACTOR,
	PUERTI_RICO_STATE_CODE,
	DEFAULT_SHADING_VAL,
	PANEL_OVERLAP_THRESHOLD,
	GROUND_MOUNT_DEFAULT_PITCH,
	NORMAL_FACET_DEFAULT_PITCH,
	STARTING_HEIGHT_DEFAULT_FEET,
	STROKE_COLOR_FOR_TEMP_ADDED_PANEL,
	STANDARD_IMAGERY_SIZE,
	KONVA_OBS_GROUP,
	DEV_STROKE_COLOR,
	DEV_STROKE_FACET_COLOR,
	PREMIUM_IMAGERY_PROVIDERS,
	MANUAL_ONLY_IMAGERY_PROVIDERS,
	BASE_SHADING,
	MIN_CUSTOM_SHADING,
	MAX_CUSTOM_SHADING,
	PREDEFINED_SHADING_VALUES,
	ROOF_DESIGN_MODES,
	SHADING_STATUS,
	FLAT_ROOF_DEFAULT_PITCH,
	FACET_DEFAULT_FILL_COLOR_ROOF_TOOL,
	PANEL_OPS,
	SOLAR_FACET_OPS,
	SOLAR_FACET_OPS_WITH_BUTTON_ON_UI,
	ROOF_FACET_OPS,
	ALL_ACTIONS,
	FINAL_IMAGE_PADDING_VALUE_PERCENTAGE,
	FACET_TYPE,
	RIGHT_PANEL_MOBILE_BREAKPOINT,
	MAX_BILL_AMOUNT,
	TOOL_RENDER_MODE
};
